import Vue from 'vue';
import FirstStep from '../../components/partials/add-capacity-equipment-steps/FirstStep';
import * as api from '../services/api';
import * as dateFormat from '../../helpers/dateFormat';
import * as blockui from '../../helpers/block-ui';

// Kapasite ekipmani ekleme/klonlama TEK adimdir. Eskiden ikinci bir adim daha vardi
// (kaynak sayisi / cikis sayisi ve o sayida cihaz secimi) ama bu sayilar hicbir yerde
// okunmuyordu; kaynak-cikis iliskilerinin kendisi ekipman detay ekranindan (overlay)
// duzenlenmeye devam ediyor. Bu yuzden burada ne sihirbaz adimlari ne de InputDevices /
// OutputDevices gonderimi kaldi.
export default {
  data() {
    return {
      capacityEquipment: {},
      formData: {},
    };
  },
  props: [
    'selectedCapacityEquipment',
    'isUpdate',
    'selectedTable',
  ],
  components: {
    'first-step': FirstStep,
  },
  mounted() {
    const self = this;
    self.capacityEquipment = self.selectedCapacityEquipment;
    self.$nextTick(() => {
      Vue.justNumber();
      $("form[name='stepForm']").validate();
    });

    $('#capacity_equipment_modal').on('hidden.bs.modal', (e) => {
      self.$emit('close');
    });
  },
  methods: {
    openRoomModal() {
      this.$emit('open-room-modal');
    },
    saveCapacityEquipment(e) {
      const self = this;
      e.preventDefault();
      const form = $("form[name='stepForm']");

      self.$refs['first-step-child'].$v.$touch();
      if (self.$refs['first-step-child'].$v.$invalid || !form.valid()) {
        return;
      }

      self.formData = {};
      $.map(form.serializeArray(), (item) => {
        if (item.name === 'DateOfInstallation' || item.name === 'DateOfWarrantyStart' || item.name === 'ExpectedLifeEndDate' && item.value) {
          Object.assign(self.formData, { [item.name]: item.value ? dateFormat.postDateFormatToDate(dateFormat.postDateFormat(item.value)) : null });
        } else {
          Object.assign(self.formData, { [item.name]: item.value });
        }
      });

      const formDataWithFormattedDates = self.formData;
      if (formDataWithFormattedDates.DateOfInstallation) {
        formDataWithFormattedDates.DateOfInstallation = dateFormat.postDateFormat(dateFormat.viewDateFormat(formDataWithFormattedDates.DateOfInstallation));
      }
      if (formDataWithFormattedDates.DateOfWarrantyStart) {
        formDataWithFormattedDates.DateOfWarrantyStart = dateFormat.postDateFormat(dateFormat.viewDateFormat(formDataWithFormattedDates.DateOfWarrantyStart));
      }
      if (formDataWithFormattedDates.ExpectedLifeEndDate) {
        formDataWithFormattedDates.ExpectedLifeEndDate = dateFormat.postDateFormat(dateFormat.viewDateFormat(formDataWithFormattedDates.ExpectedLifeEndDate));
      }

      blockui.blockModal(self);

      // Klon modunda forma gizli bir SourceId girdisi eklenir; o varsa istek Clone ucuna
      // gider ve sunucu ekipmanla birlikte alt cihazlari da kopyalar.
      const save = formDataWithFormattedDates.SourceId
        ? api.cloneCapacityEquipment
        : api.saveCapacityEquipment;

      save(formDataWithFormattedDates).then((response) => {
        if (response.body.IsSuccess) {
          toastr.success(self.translate('save_successfully'));
          if (self.$route.meta.xyz) {
            Vue.getDatatables('.capacity_equipment_list');
            if (!self.isUpdate) {
              self.$parent.slc.rooms.ChildCount = self.$parent.slc.rooms.ChildCount ? self.$parent.slc.rooms.ChildCount + 1 : 1;
            }
          } else if (!self.isUpdate) {
            if ($('[name=capacity_equipment_list]').length > 0) {
              if (!$(`table [data-id='${self.formData.RoomId}']`).eq(0).closest('tr').hasClass('shown')) {
                $(`table [data-id='${self.formData.RoomId}']`).eq(0).closest('tr').find('.details-control')
                  .removeClass('m--hide');
                $(`table [data-id='${self.formData.RoomId}']`).eq(0).closest('tr').find('.details-control')
                  .eq(0)
                  .click();
              } else {
                Vue.getDatatables($(`table [data-id='${self.formData.RoomId}']`).closest('tr').next().find('table'));
              }
            } else {
              self.$store.dispatch('getRelatedCapacityEquipmentList', self.$router.history.current.name);
            }
          } else {
            Vue.getDatatables($(`table [data-id='${self.formData.RoomId}']`).closest('tr').next().find('table'));
          }
          $('#capacity_equipment_modal').modal('toggle');
        } else {
          toastr.error(response.body.Message);
        }
        blockui.unBlockModal();
      }, (error) => {
        blockui.unBlockModal();
      });
    },
  },
};
